import React, { useState, useCallback } from 'react';
import { CategoryLink } from '../../atoms/CategoryLink';
import { useGsapCategoryScroll } from '../../../hooks';
import styles from './LeftCategories.module.css';

interface CategoryItem {
  label: string;
  href?: string;
  active?: boolean;
}

interface LeftCategoriesProps {
  items: CategoryItem[];
  onCategorySelect?: (item: CategoryItem, index: number) => void;
}

export const LeftCategories: React.FC<LeftCategoriesProps> = ({
  items,
  onCategorySelect,
}) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const handleIndexChange = useCallback(
    (index: number) => {
      setSelectedIndex(index);
      if (onCategorySelect && items[index]) {
        onCategorySelect(items[index], index);
      }
    },
    [items, onCategorySelect]
  );

  const {
    containerRef,
    registerCategoryRef,
    getLoadingBarWidth,
    isCategoryActive,
  } = useGsapCategoryScroll(items.length, handleIndexChange);

  const handleCategoryClick = (item: CategoryItem, index: number) => {
    setSelectedIndex(index);
    onCategorySelect?.(item, index);
  };

  return (
    <nav
      className={styles.leftCategories}
      aria-label="Sections"
      ref={containerRef}
    >
      <ul className={styles.categoryList}>
        {items.map((item, index) => (
          <li
            key={`${item.label}-${index}`}
            className={styles.categoryItem}
            ref={registerCategoryRef(index)}
          >
            <CategoryLink
              label={item.label}
              href={item.href}
              active={item.active}
              selected={selectedIndex === index}
              onClick={() => handleCategoryClick(item, index)}
              // Scroll animation props
              loadingBarWidth={getLoadingBarWidth(index)}
              isActive={isCategoryActive(index)}
            />
          </li>
        ))}
      </ul>
    </nav>
  );
};
